import { BidsSortable } from "components/bids";
import { Transition } from "components/shared/column";
import { paths } from "helpers/paths";
import { tableContainer } from "helpers/redux";
import React from "react";
import { withRouter } from "react-router-dom";
import Filters from "./filters";
import List from "./list";

class DocumentTracking extends BidsSortable {
    state = {
        activeSort: {},
    };

    renderHead = () => {
        const close = () => {
            this.props.back ? this.props.back() : this.props.history.push(paths.finances);
        };

        return (
            <div className="book-list__head">
                <div className="book-list__head-close close close--sm" onClick={close} />
                <div className="book-list__head-title">
                    Отслеживание документов
                    {this.renderCounter()}
                </div>
                <div className="btn-toolbar"></div>
            </div>
        );
    };

    render() {
        const { params, mergeParams, organizationTimezone } = this.props;
        const { activeSort } = this.state;
        const listProps = {
            activeSort,
            organizationTimezone,
            sortData: this.sortData,
        };

        return (
            <Transition dir="full">
                <div className="page-book__list book-list list">
                    {this.renderHead()}
                    <Filters params={params} mergeParams={mergeParams} />
                    <List {...this.props} {...listProps} />
                </div>
            </Transition>
        );
    }
}

export default withRouter(tableContainer(DocumentTracking, "document-tracking"));
